var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.src && !_vm.loading,
      expression: "src && !loading"
    }],
    staticClass: "customImage",
    class: _vm.customClass,
    attrs: {
      "src": _vm.src,
      "alt": _vm.alt || (_vm.keyAlt ? _vm.translations[_vm.keyAlt] : ''),
      "title": _vm.translations[_vm.keyTitle] || '',
      "width": _vm.width,
      "height": _vm.height,
      "srcset": _vm.srcset,
      "loading": _vm.loading,
      "objectFit": _vm.objectFit
    },
    on: {
      "load": _vm.load
    }
  });
}
var staticRenderFns = []

export { render, staticRenderFns }